import type { SystemMessage } from '../../types/systemMessage';

export const MESSAGE_REGISTRY: Record<string, SystemMessage> = {};

export function registerMessage(message: SystemMessage): SystemMessage {
  MESSAGE_REGISTRY[message.slug] = message;
  return message;
}
